module.exports = __webpack_public_path__ + "img/DamEnvironmentQuestion.a57dac90.svg";